export enum Permission {
  /**
   * Accesses
   */
  CAN_ACCESS_ITRACKER = 'can-access-itracker',
  CAN_ACCESS_NEXUS = 'can-access-nexus',
  CAN_ACCESS_REPORTING = 'can-access-reporting',
}
